import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {ModalParagraph} from '@/components/ui/modal-atoms/ModalAtoms'

export const StyledBrowserEmbeddedOverlay = styled(Flexbox)`
    ${() => css`
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(8px);
        z-index: 9999;

        transition: opacity 0.3s;
        opacity: 1;
    `}
`

export const StyledBrowserEmbeddedContent = styled(Flexbox)`
    ${({theme}) => css`
        background: ${theme.palette.neutral.white};
        width: 85%;
        height: 95%;
        overflow-y: auto;
        border-radius: 8px;
        position: relative;
        box-shadow: ${theme.shadows.sm};
        & button {
            padding: 0;
        }

        @media (max-width: 768px) {
            width: 90%;
            height: 90%;
        }

        & button {
            margin: ${theme.spacing * 4}px ${theme.spacing * 8}px;
        }
    `}
`

export const StyledBrowserEmbeddedContentParagraph = styled(ModalParagraph)`
    ${({theme}) => css`
        font-weight: 600;
        ${theme.typography.textSm};
        white-space: pre-line;
    `}
`
